module.exports = __webpack_public_path__ + "assets/img/ru-10a8a347.png";